import { useQuery } from '@apollo/client';
import { USER_PROFILE } from 'queries';
import React from 'react';
import { Button } from 'react-bootstrap';

function HeroWorkshop(props) {
    const userProfile = useQuery(USER_PROFILE);
    
return(
    <div className="card container mt-5 bg-transparent border-0" >
        <div className="row no-gutters">
            <div className="col-md-4 cover offset-1 rounded-lg m-auto bg-info">
                <img src={props.data.imageurl} className="card-img square-img bg-warning" alt="foto"/>
            </div>
            <div className="col-md-6 mr-auto">
                <div className="card-body">
                    <h2>{props.data.judul}</h2>
                    <p className="card-text">{props.data.deskripsi}</p>
                    <Button className="mt-3 shadow btn btn-secondary w-100"
                            onClick= {() => handleClick(props.data.type, userProfile.data?.profile.schoolType, props.isLogin)}>
                                Register</Button>
                    {/* <Button className="mt-3 shadow btn btn-primary w-100" onClick= {() => window.open(props.data.linkBukuPetunjuk)}>
                                Download Guide Book</Button> */}
                </div>  
            </div>
        </div>
    </div>
    )
}

function handleClick(typeprops, typeuser, isLogin){
    
    if (isLogin){
        window.location = "/event/Workshop/register"
        return 1;
    }
    else{
        window.location = "/signin";
        return 0;
    }
    
}

export default HeroWorkshop;